module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/126Hib4/tc-custom/9781423608677.jpg?1709781201218",
      "alt": "This image is the cover for the book 101 Things To Do With Canned Biscuits, 101 Things To Do With"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("101 Things To Do With Canned Biscuits, 101 Things To Do With\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Go beyond butter and jam and find new ways to use canned biscuits in every meal!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" If your idea of heaven is a golden, flaky, piping-hot biscuit right out of the oven and slathered with butter and jam, wait until you try these delicious culinary creations! From the author of the best-selling "), _c('i', [_vm._v("101 Things to Do with Ramen Noodles")]), _vm._v(", featured on the "), _c('i', [_vm._v("Today")]), _vm._v(" show and the Food Network, comes "), _c('i', [_vm._v("101 Things to Do with Canned Biscuits.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Toni Patrick takes plain old canned biscuits and turns them into filling breakfast egg stratas and bakes, Turkey Cheese Pockets and BBQ Beef Cups for lunch, and dinners of meat pies and Chicken and Dumplings. Is your mouth watering yet? Sides and appetizers such as Turkey Empanadas, Fruit Pin Wheels, and Cheese Balls make perfect companions for parties and sports-day treats, and don't forget the desserts of Sweet Potato Bread Pudding, Praline Meltaways, Strawberry Cream Cheese Biscuits, and more!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Toni Patrick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Toni Patrick is also the author of 101 Things to Do with Ramen Noodles, 101 Things to Do with Mac & Cheese, and 101 Things to Do with Canned Biscuits. She lives in Colorado.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0